import React, { useEffect, useState } from 'react'
import { AiOutlineClockCircle } from 'react-icons/ai'
import axios from "./../../../axios"
import { useSelector } from 'react-redux';
import VerticalProgBar from './VarticalProgressBar/VerticalProgBar';


function AdaptiveAss() {
    // const navigate = useNavigate()
    const [pendingAss, setPendingAss] = useState({
        openAssignment: false,
        assessmentId: null,
    });
    const [pendingCard, setPendingCard] = useState([]);
    const currentUser = useSelector((state) => state.user.currentUser);
    const [isGettingData, setIsGettingData] = useState(true);
    const [todaysData, setTodaysData] = useState([]);
    const [previousData, setPreviousData] = useState([]);
    const today = new Date().toISOString().split("T")[0];
    const [errMsg, setErrMsg] = useState("Something went Wrong!");
    const [unAuthPopup, setUnAuthPopup] = useState(false);
    const [instructionsPopup, setInstructionsPopup] = useState(false);
    const [notAllowedPopup, setNotAllowedPopup] = useState(false);
    useEffect(() => {
        const getStudentResponse = async () => {
            let updatedQuestion = [];
            try {
                // // let res = await axios.get(`/assessment/getForStudent/${assessmentId}`);
                // // res &&
                // //     res.data.data?.questions.forEach((question, index) => {
                // //         if (!question.type.is_manually_graded) {
                // //             updatedQuestion.push({
                // //                 question_id: question?.id,
                // //                 answer: {
                // //                     key: " ",
                // //                     explanation: " ",
                // //                 },
                // //                 mandatory: question?.is_mandatory,
                // //                 index,
                // //             });
                // //         } else {
                // //             updatedQuestion.push({
                // //                 question_id: question?.id,
                // //                 description: " ",
                // //                 mandatory: question?.is_mandatory,
                // //                 index,
                // //             });
                // //         }
                // //     });
                // setQuestionsAnswer([...updatedQuestion]);
                // setPendingData(res.data.data);
                // TBD: modify below to use set remaining seconds (current_time - (start_time+ total_duration))
                setIsGettingData(false);
            } catch (error) {
                console.log(error);
                setUnAuthPopup(true);
                setErrMsg(error.response.data.message);
            }
        };
        getStudentResponse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const timeHelper = (a) => {
        const dateObj = new Date(a);
        const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
        const localDate = new Date(dateObj - userOffset); // Convert to local time

        const day = localDate.getDate().toString().padStart(2, "0");
        const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
        const year = localDate.getFullYear();
        const outputDateString = `${day}/${month}/${year}`;
        return outputDateString;
    };
    const formatTime = () => {
        // seconds
        if (30) {
            const minutes = Math.floor(30 / 60);
            const remainingSeconds = 30 % 60;

            return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
                .toString()
                .padStart(2, "0")}`;
        }
    };
    const [difficulty, setDifficulty] = useState(0); // Initial difficulty level
    const [skills, setSkills] = useState(70); // Initial skills level

    const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
    const skillsLevels = [
        "Create",
        "Evaluate",
        "Analyze",
        "Apply",
        "Understand",
        "Remember",
    ];

    // Simulate dynamic data updates
    useEffect(() => {
        const updateProgress = () => {
            setDifficulty(Math.floor(Math.random() * 101)); // Random between 0-100
            setSkills(Math.floor(Math.random() * 101));
        };
        updateProgress()
    }, [])
    return (
        <div>
            {!unAuthPopup && (
                <div className="hederContainer1" style={{ height: "75vh" }}>
                    <div>
                        <div className="d-flex justify-content-between w-100  ">
                            <div>
                                {/* <span className="quesHeading">{pendingData?.name}</span> */}
                                <span className="quesHeading">{'MyAssessment'}</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between w-100 mt-1">
                            <div>
                                <span className="subTitle2">
                                    {/* {pendingData?.subject_id?.name} */}
                                    {`English`}
                                </span>
                                &nbsp;
                                <span>|</span> &nbsp;
                                <span className="subTitles3">Scheduled</span> &nbsp;
                                <span className="subTitle2">
                                    {timeHelper(new Date())}
                                </span>
                                &nbsp;
                            </div>
                            <div className="">
                                <div className="subTitle2 mr-3">
                                    <AiOutlineClockCircle /> &nbsp;{formatTime()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
                        {/* {pendingData?.questions?.length > 0 &&
                            pendingData?.questions?.map((item, index) => (
                                <div
                                    onClick={(e) => setQuestionNo(index)}
                                    className={
                                        questionNo > index
                                            ? "QuestionActiveNo"
                                            : "QuestionNoNonActive"
                                    }
                                    style={{
                                        borderColor: item.is_mandatory
                                            ? "#AC1616"
                                            : questionNo === index
                                                ? "#F99933"
                                                : questionNo > index
                                                    ? "#F77F00"
                                                    : "#668598",
                                        color:
                                            questionNo === index
                                                ? "#F99933"
                                                : questionNo > index
                                                    ? "#F77F00"
                                                    : "#668598",
                                        backgroundColor:
                                            questionNo > index ? "#FEF2E5" : "transparent",
                                        minWidth: "30px",
                                    }}
                                >
                                    Q{index + 1}
                                </div>
                            ))} */}
                    </div>
                    <div className="mt-4 allquestionTypesContainer row" style={{ height: "69%" }}>
                        <div className="col-6">
                            {/* {pendingData?.questions.length > 0 &&
                                !pendingData?.questions[questionNo]?.type?.is_manually_graded ? (
                                <CheckBoxType
                                questionNo={questionNo + 1}
                                question={pendingData?.questions[questionNo]}
                                setQuestionsAnswer={setQuestionsAnswer}
                                questionsAnswer={questionsAnswer}
                                />
                            ) : (
                                <SubmisshionByUpload
                                questionNo={questionNo + 1}
                                question={pendingData?.questions[questionNo]}
                                setQuestionsAnswer={setQuestionsAnswer}
                                questionsAnswer={questionsAnswer}
                                />
                            )} */}
                        </div>
                        <div className="col-6">
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <VerticalProgBar
                                    title="Difficulty"
                                    levels={difficultyLevels}
                                    progress={difficulty}
                                />
                                <VerticalProgBar
                                    title="Skills"
                                    levels={skillsLevels}
                                    progress={skills}
                                />
                            </div>
                        </div>


                        <div>
                            <div className="nextBtnContainerAssignment">
                                {/* {pendingData?.questions?.length > questionNo + 1 && (
                                    <button
                                        className="nextBtnQue"
                                        onClick={(e) => setQuestionNo(questionNo + 1)}
                                    >
                                        Next
                                    </button>
                                )} */}

                                <button
                                    className="nextBtnQue"
                                // onClick={(e) => setQuestionNo(questionNo + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AdaptiveAss